<template lang="pug">
v-slide-y-reverse-transition
  v-col(v-if="task")
    //- TODO TaskTimer
    //- v-overlay(:value="overlay" absolute)
    //-   v-btn() Отправить задание
    //- task-timer(@timer-stop="(val) => overlay = val")
    validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
      v-row
        v-col
          h1 {{ task.title }}
          p(v-html="task.description")
      v-row
        v-col
          v-form
            v-card(v-for="(unit, idx) in task.task_units" :key="unit.id" class="sdo-card mb-4")
              v-card-title {{ unit.title }}
              v-card-text(class="py-0" v-html="unit.description") {{ unit.description }}
              component(
                :is="getComponentNameByType(unit.type)"
                :task-unit="unit"
                :index="idx"
                @answer="acceptAnswer(unit.id, $event)"
              )
      v-row
        v-col
          sdo-back-button
          v-btn(
            @click="handleSubmit(saveAnswers)"
            color="success"
            :loading="loading"
            rounded depressed
          ) Ответить

</template>

<script>
import TaskService from '@/services/API/TaskService';
import TypeOneOfMany from '@/modules/Tasks/TaskUnits/components/passing/TypeOneOfMany.vue';
import TypeLink from '@/modules/Tasks/TaskUnits/components/passing/TypeLink.vue';
import TypeMark from '@/modules/Tasks/TaskUnits/components/passing/TypeMark.vue';
import TypeTextAnswer from '@/modules/Tasks/TaskUnits/components/passing/TypeTextAnswer.vue';
import TypeManyOfMany from '@/modules/Tasks/TaskUnits/components/passing/TypeManyOfMany.vue';
import { TASK_UNIT_TYPE_NAMES } from '@/modules/Tasks/TaskUnits/constants';
import TypeFile from '@/modules/Tasks/TaskUnits/components/passing/TypeFile.vue';
import TaskTimer from '../components/TaskTimer.vue';

export default {
  name: 'TaskPass',
  components: {
    TaskTimer,
  },
  data: () => ({
    journalId: null,
    overlay: false,
    snack: true,
    task: null,
    answers: [],
    loading: false,
    // timerLoading: true,
    TASK_UNIT_TYPE_NAMES,
  }),
  mounted() {
    this.getJournal();
    this.getTask(this.$route.params.id);
  },
  methods: {
    getTask(id) {
      this.loading = true;
      this.$rHandler(
        TaskService.getTaskForPass(id, { expand: 'task_units' }),
        (r) => {
          this.task = r.data.data;
          this.prepareAnswersStructure();
          this.loading = false;
        },
      );
    },
    prepareAnswersStructure() {
      this.answers = this.task.task_units.map((unit) => ({
        task_unit_id: unit.id,
      }));
    },
    acceptAnswer(taskId, answerInfo) {
      const givenAnswer = this.answers.find((a) => a.task_unit_id === taskId);
      this.$set(givenAnswer, answerInfo.fieldName, answerInfo.answer);
    },
    // saveAnswers() {
    //   this.loading = true;
    //   const data = {
    //     group_id: this.$route.query.groupId || 1,
    //     answers: this.answers,
    //   };
    //   this.$rHandler(
    //     TaskService.saveAnswers(this.$route.params.id, data),
    //     () => {
    //       this.loading = false;
    //       this.$router.go(-1);
    //       this.$toasted.success('Задание отправлено на проверку', { duration: 3000 });
    //     },
    //     () => {},
    //     this.$refs.obs,
    //   );
    //   this.loading = false;
    // },
    getComponentNameByType(type) {
      switch (type) {
        case TASK_UNIT_TYPE_NAMES.readingMark: {
          return TypeMark;
        }
        case TASK_UNIT_TYPE_NAMES.textAnswer: {
          return TypeTextAnswer;
        }
        case TASK_UNIT_TYPE_NAMES.link: {
          return TypeLink;
        }
        case TASK_UNIT_TYPE_NAMES.choiceOneOption: {
          return TypeOneOfMany;
        }
        case TASK_UNIT_TYPE_NAMES.choiceSeveralOptions: {
          return TypeManyOfMany;
        }
        case TASK_UNIT_TYPE_NAMES.file: {
          return TypeFile;
        }
        default: {
          return false;
        }
      }
    },
    getJournal() {
      const params = {
        'search[task_id]': this.$route.params.id,
        'search[user_id]': this.$user.data.id,
        'search[status]': 1,
        sort: '-id',
        'per-page': 200,
      };
      this.$rHandler(
        this.$api.journal.getJoarnalAnswer({ params }),
        ({ data }) => {
          if (data.data.length) this.journalId = data.data[0].id;
          else this.createJournal();
        },
      );
    },
    createJournal() {
      const params = {
        task_id: this.$route.params.id,
        group_id: this.$route.query.groupId,
      };
      this.$rHandler(
        this.$api.journal.createJoarnalAnswer(params),
        ({ data }) => {
          // this.initTimer = data.data.created_at;
          this.journalId = data.data.id;
        },
      );
    },
    saveAnswers() {
      this.loading = true;
      const data = {
        group_id: this.$route.query.groupId,
        answers: this.answers,
      };
      this.$rHandler(
        this.$api.journal.saveJoarnalAnswer(this.journalId, data),
        () => {
          this.loading = false;
          this.$router.go(-1);
          if (this.task.type === this.$conf.TASK_TYPES.mixed) this.$toasted.success('Задание отправлено на проверку', { duration: 3000 });
        },
        () => {},
        this.$refs.obs,
      );
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep table, ::v-deep th, ::v-deep td {
  border: 1px solid;
}
</style>
